export const promotionEndpoints = {
  list: '/v1/promotions',
  create: '/v1/promotions',
  detail: (id: string) => `/v1/promotions/${encodeURIComponent(id)}`,
  update: (id: string) => `/v1/promotions/${encodeURIComponent(id)}`,
  delete: (id: string) => `/v1/promotions/${encodeURIComponent(id)}`,
  options: '/v1/promotions/options',
} as const;
